import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

/** Detect if a string contains Bengali script characters. */
export function hasBengali(text) {
    if (!text) return false;
    return /[\u0980-\u09FF]/.test(text);
}

/** Read a File as data URL (base64). */
export function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
